import type { ReactNode } from "react";
import { Button, Sheet } from "./ui";

/**
 * 一次性灵力提醒的共用弹窗。
 *
 * 组件只负责展示，不决定“第一次”也不写存储；确认状态由账号侧接口负责。
 */
export function PowerCostNotice({
  open,
  children,
  onConfirm,
  onClose,
}: {
  open: boolean;
  children: ReactNode;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Sheet
      open={open}
      title="灵力提醒"
      headerDivider={false}
      onClose={onClose}
    >
      <div className="power-cost-notice">
        <p>{children}</p>
        <Button tone="primary" block onClick={onConfirm}>
          我知道了
        </Button>
      </div>
    </Sheet>
  );
}
